import * as _ from 'lodash';
import { useState } from 'react';
import { IEwtSummary, IRecipient, ITargetItem } from '@nkr/models/index';
import { Button, Panel } from 'react-bootstrap';
import { ListType } from '@nkr/views/target-new/list-type';
import PatientGrid from '@nkr/views/target-new/patient-grid';
import { GridReadyEvent } from 'ag-grid-community';

interface IProps {
    list: ITargetItem[],
    cutoff: number,
    onShowEwt: (summary: IEwtSummary, initialCount: any) => void,
    onShowFwt: (recipient: ITargetItem) => void,
    onShowMortalityBreakdown: (type: number, recipient: ITargetItem) => void,
    onGridReady: (e: GridReadyEvent) => void
}

const Vouchers = (props: IProps) => {
    const [toggle, setToggle] = useState(false);

    const getList = () => {
        let sortedRows = _.orderBy(props.list, [
            item => {
                return item.isMatchable ? 0 : 1;
            },
            item => {
                return item.sortOrder;
            },
            item => {
                return item.recipientAlias;
            }
        ]);

        let filteredList = sortedRows.filter(x => {
            let toggleFilter = toggle ? x.withinTwoWeeks : true;
            return toggleFilter;
        })

        return filteredList;
    };

    const handleToggle = () => {
        setToggle(!toggle);
    };

    const list = getList();

    return (
        <Panel>
            <Panel.Heading style={{ padding: '2px 4px', fontWeight: 600 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ fontSize: 16 }}><strong>Voucher Holders:</strong>{` Not Matched, DDR >= ${props.cutoff * 100.0}%, (ABO = O or NKR cPRA > 99%), On Dialysis, WT >= 4 months, FWT >= 2 months, excludes compatibles`}</span>
                </div>
            </Panel.Heading>

            <Panel.Body style={{ padding: '2px 4px' }}>
                <PatientGrid 
                    list={list}
                    type={ListType.Vouchers}
                    fullSize={true}
                    showTargetColumn={false}
                    showEwtModel={true}
                    showFwtModel={true}
                    suppressed={false}
                    forceAutoHeight={list.length == 0}
                    noRowsText='No high risk vouchers found...'                    
                    useRowClass={false}
                    isHighDeclines={true}
                    onGridReady={props.onGridReady}
                    onShowEwt={props.onShowEwt}
                    onShowFwt={props.onShowFwt}
                    onShowMortalityBreakdown={props.onShowMortalityBreakdown}
                />
            </Panel.Body>
        </Panel>
    );
}

export default Vouchers;